// Generated by scripts/generate.py. Do not edit.
export const STATE_SCOPE_ACTIVITY = "activity";
export const STATE_SCOPE_BUNDLE = "bundle";
export const STATE_SCOPE_SPACE = "space";
export const STATE_SCOPE_USER = "user";
export const STATE_SCOPE_REQUIREMENT = "requirement";
